<template>
  <div class="selectLetterDiv">
    <a v-text="$t('proprietor.selectMansionModal.all')" :style="latter?'color:#333333':'color:#FABE00'" @click="changeLetter(null)"></a>
    <template v-for="(item,index) in indexLetter">
      <a v-text="item" class="letterStyle" :style="item == latter ? 'color:#FABE00':''" @click="changeLetter(item)"></a>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'ptSelectLatter',
    props:{
      value:{
        type: [Object, Array],
      },
    },
    data() {
      return {
        indexLetter: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
        latter:null
      }
    },
    watch:{
      value (val) {
        this.latter = val
      },
      latter(val){
        this.$emit('input',val)
      }
    },
    methods:{
      changeLetter(item){
        this.latter = item;
      }
    }
  }
</script>

<style scoped lang="less">
  .selectLetterDiv{
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    .letterStyle{
      width: 25px;display: inline-block;text-align: center;color: #666;
    }
  }
</style>